import React from 'react';

const SUIT_SYM = { spades: '♠', hearts: '♥', diamonds: '♦', clubs: '♣' };
const RED = new Set(['hearts', 'diamonds']);

/**
 * Physical-looking playing card for casino presentation.
 * Pure presentational — no game logic.
 */
export default function PlayingCard({
  card,
  faceUp = false,
  size = 'opponent', // 'local' | 'opponent' | 'center'
  dealIn = false,
  style,
}) {
  const suit = card?.suit;
  const rank = card?.rank;
  const red = RED.has(suit);
  const cls = [
    'cv2-card',
    faceUp ? '' : 'is-back',
    dealIn ? 'deal-in' : '',
  ].filter(Boolean).join(' ');

  const sizeStyle =
    size === 'local'
      ? undefined
      : size === 'center'
        ? { width: 'var(--cv2-card-center-w)', height: 'var(--cv2-card-center-h)' }
        : undefined;

  if (!faceUp) {
    return (
      <div className={cls} style={{ ...sizeStyle, ...style }} aria-hidden="true">
        <div className="cv2-card-back-mark" />
      </div>
    );
  }

  return (
    <div className={cls} style={{ ...sizeStyle, ...style }}>
      <div className={`cv2-card-face ${red ? 'red' : 'black'}`}>
        <div className="cv2-card-corner">
          <span>{rank}</span>
          <span>{SUIT_SYM[suit] || ''}</span>
        </div>
        <div className="cv2-card-center-glyph">{SUIT_SYM[suit] || ''}</div>
        <div className="cv2-card-corner flip">
          <span>{rank}</span>
          <span>{SUIT_SYM[suit] || ''}</span>
        </div>
      </div>
    </div>
  );
}

export function LocalHand({ hand, faceUp = true, dealKeys }) {
  if (!hand || hand.length === 0) return null;
  return (
    <div className="cv2-hand is-local" style={{ left: '50%', top: '76%' }}>
      {hand.map((card, i) => (
        <PlayingCard
          key={i}
          card={card}
          faceUp={faceUp}
          size="local"
          dealIn={dealKeys ? dealKeys.has(i) : false}
        />
      ))}
    </div>
  );
}

export function OpponentHand({ hand, faceUp = false, anchor, dealKeys }) {
  if (!hand || hand.length === 0) return null;
  return (
    <div
      className="cv2-hand is-opponent"
      style={{ left: `${anchor.left}%`, top: `${anchor.top}%` }}
    >
      {hand.map((card, i) => (
        <PlayingCard
          key={i}
          card={card}
          faceUp={faceUp}
          size="opponent"
          dealIn={dealKeys ? dealKeys.has(i) : false}
        />
      ))}
    </div>
  );
}
